import { createTheme } from "@mui/material";


const PortfolioTheme = createTheme({
    typography: {
        fontFamily: [
            "poppins",
            "Verdana"
        ].join(",")
    },
    breakpoints: {
        values: {
            xs: 0,
            msm: 400,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,    
        }
    }
})

export default PortfolioTheme;